import React, { Component, useDebugValue } from "react";
import {withRouter} from 'react-router-dom';
import { connect } from 'react-redux';
import moment from "moment";
import { Form, FormGroup, FormFeedback, Col, Label, Input, Button, 
          Row, CustomInput, Popover, PopoverHeader, PopoverBody,
          Dropdown, DropdownItem, DropdownToggle, DropdownMenu,
          Modal, ModalBody, ModalHeader, Table
        } from "reactstrap";
import Tooltip from '../../../../../components/UI/TooltipIcon/TooptipIcon';
// import ErrorMessage from '../../../../components/Message/ErrorMessage/ErrorMessage';
import Toggle from "react-toggle";
import "react-toggle/style.css";
import Select from "react-select";
import Loading from '../../../../../hoc/Loading/Loading';
import axios from '../../../../../axios';
import * as actionCreators from '../../../../../modules/actions/index';
import * as url from '../../../../../utils/url';
import LinkChart from '../../../../../assets/placeholders/dashboard_sample.png';
import { privacyLabel, newDashboard} from '../../../../../utils/constants';
// import Dropdown from '../../Reusable/Dropdown'
import DatePicker from 'react-datepicker';
import CreateDashboard from "../../Reusable/CreateDashboard";



class DashboardSettings extends Component {
  viewUserInputRef = React.createRef();
  viewUserTableRef  = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      title : '',
      customUser:'',
      newUserAdded:null,
      dropdownOpen:false,
      dropdownFilter:false,
      isDateApplied:false,
      isDatePicker:false,
      errMsg:'',
      privacy: 'PRIVATE',
      permission: 'VIEW',
      preventCreate:false,
      isResourceSelect:null,
      startDate:null,
      endDate:moment(new Date()),
      isPrivacySettingsChanged: false,
      error: false,
      activeFilterMenu:'',
      errorMessage: '',
      displayUsers:[],
      isPrivacy: this.props.isPrivacy,
      isUserList:false,
      invitedUsers: [],
      privacyPopoverOpen: false,
      permissionPopoverOpen: false,
      filteredBenchmarkData: null,
      updatedFields:[],
      displayType:null,
    };
    this.timer = null;

  }

  

  

  // componentDidMount() {
  //   window.scrollTo(0, 0);
  //   if( (this.props.chartDetails.createdBy && this.props.chartDetails.createdBy._id) && this.props.chartDetails.createdBy._id === this.props.user._id ) {
  //     if(this.state.isUserList || this.state.privacy==='CUSTOM'){
  //       this.getUserList()
  //     }
  //   }
  // }

  closeUserSearch=()=>{
    this.setState({displayUsers:[]})
  }


  closeFilterMenu=()=>{
    this.setState( prevState=>({ dropdownFilter: false }) )
  }  
  
 
  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() { 
    document.removeEventListener("mousedown", this.handleClickOutside);
   }

   handleClickOutside = (event) => { 
    if(this.viewUserInputRef){
      if(this.viewUserInputRef.current){
        let input =this.viewUserInputRef.current
       
        if(this.viewUserTableRef){
          if(this.viewUserTableRef.current){
            let ut=this.viewUserTableRef.current
            if( (input &&  !input.contains(event.target))  &&  ( ut && !ut.contains(event.target)) ){
              this.closeUserSearch()
            }
          }
        }
      }
    }
}
 

  editTask=(field, isUndo)=>{
    // console.log('field---', field)
    let {updatedFields, task_copy, task, removedFields }=this.state
  
    if(updatedFields.indexOf(field)==-1){
      updatedFields.push(field)
      this.setState({updatedFields})
    } else {
       let res =updatedFields.filter(e=> e!=field)

      this.setState({ updatedFields:res })
    }
  }




  changeDashboardTitle = (event) => {
    const { value } = event.target;
    this.setState({ title:value })
  }


  getUserList=()=>{
    let {displayUsers}=this.state
    if(displayUsers.length===0){
      axios.get(url.userListArray).then((response) => {
        this.setState({ displayUsers: response.data.data.map(e=> {
            if(e.firstName && e.lastName){
              return { "label": `${e.firstName}, ${e.lastName}`, "value": e._id, "permissions":0 }
            } else if (e.firstName || e.lastName){
              let name = e.firstName && e.firstName.length>0?e.firstName:e.lastName
              return { "label": `${name}`, "value": e._id, "permissions":0 }
            } else if (!e.firstName && !e.lastName) {
              return { "label": `${e.email}`, "value": e._id, "permissions":0 }
          }
          })
        });


    
      }).catch((error) => {
          console.log(error);
      })
    }
   
  }

  handleOptionChange = changeEvent => {
    // console.log(changeEvent.target)
    let permission = '';
    if (changeEvent === 'ENTERPRISE') {
      permission = 'VIEW';
      this.setState({
        privacy: changeEvent,
        permission,
        invitedUsers: [],
        isUserList:false
      });
    }  else if (changeEvent === 'CUSTOM'){
      this.setState({
        isUserList: true,
        privacy: changeEvent
      })
      // this.getUserList()
    }  else {
      this.setState({
        privacy: changeEvent,
        permission:'VIEW',
        invitedUsers:[],
        isUserList:false
      });
    }
  };

  

  handlePermissionChange = () => {
    let permission = (this.state.permission === 'EDIT') ? 'VIEW' : 'EDIT';
    this.setState({ permission: permission });
  }

  // Toggle popover
  togglePrivacySettings = () => {
    this.setState({
      privacyPopoverOpen: !this.state.privacyPopoverOpen,
      permissionPopoverOpen: false
    });
  }

  togglePersmission = () => {
    this.setState({
      permissionPopoverOpen: !this.state.permissionPopoverOpen,
      privacyPopoverOpen: false
    });
  }

  
  onUserSelect=(u)=>{
    let{invitedUsers}=this.state

    let result = invitedUsers.length==0 || invitedUsers.filter(item=> item.userId == u._id).length==0?invitedUsers.concat({
                    firstName: u.firstName,
                    lastName:u.lastName,
                    userId: u._id,
                    orgId: u.organizationId,
                    permissions:0
              }):invitedUsers

    this.setState({invitedUsers:result})
  }

  onUserSetPermissions=(p, u)=>{
    // console.log(p, u)
    let{invitedUsers}=this.state
    if(p && p!=null && p!=undefined){
        invitedUsers.forEach((item,index)=>{
          if(item.userId == u.userId ){
            invitedUsers[index].permissions = p.value
          }
      })
      this.setState({invitedUsers})
    } else {
        invitedUsers.forEach((item,index)=>{
          if(item.userId == u.userId ){
            invitedUsers[index].permissions = { label: "VIEW", value: 0 }
          }
        })
        this.setState({invitedUsers})
    }
    
  }

  renderDropDownViews=()=>{
    let{privacy}=this.state
    return(
      <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggleTaskView} className="dbPrivacyDropdown">
      <DropdownToggle caret>
        {privacyLabel[privacy]}
      </DropdownToggle>
      <DropdownMenu className="privacyOptionsContainer">
        {/* <DropdownItem header>Select a view</DropdownItem> */}
        <DropdownItem className="privacyBtnItem" onClick={()=>this.handleOptionChange('PRIVATE')}>{privacyLabel['PRIVATE']}</DropdownItem>
        <DropdownItem className="privacyBtnItem" onClick={()=>this.handleOptionChange('ENTERPRISE')}>{privacyLabel['ENTERPRISE']}</DropdownItem>
        <DropdownItem className="privacyBtnItem" onClick={()=>this.handleOptionChange('CUSTOM')}>{privacyLabel['CUSTOM']}</DropdownItem>  
      </DropdownMenu>
    </Dropdown>
    )
  }


  privacyContent=(type)=>{
    let { privacy } = this.state;

    if(type==='enable'){
      return (
        <div className="dbViewPrivacyStatusContainer">
      <span className='dbViewPrivacyStatusTxt'>
        Privacy Status: 
        {this.renderDropDownViews()}
        </span></div>)
    } else {
      return  <span className="dashboard-privacy-label">{privacy}</span>
    }
  }

  renderPrivacyOptions=()=>{
    return this.privacyContent("enable")
    // if(chartDetails && chartDetails.createdBy  && chartDetails.createdBy._id){
    //     if(chartDetails.createdBy._id===user._id){
    //       return this.privacyContent("enable")
    //     } else if(isCopied) {
    //       return this.privacyContent("enable")
    //     } else {
    //       return this.privacyContent("disable")
    //     }
    // } else {
    //   return this.privacyContent("enable")
    // }
  }

  toggleTaskView=()=> {
    this.setState( prevState=>({
      dropdownOpen: !prevState.dropdownOpen,
      // dropdownFilter: !prevState.dropdownFilter
    }));
  }


  removeUser=(user)=>{
    // console.log('u: ', user)
    let{invitedUsers}=this.state
    invitedUsers= invitedUsers.filter(e=>e.userId.toString()!=user.userId.toString())
    this.setState({invitedUsers})
  }

assignedUserDelay = ({ target })=>{
  let { value } = target;
  this.setState({customUser:value})
  clearTimeout(this.timer);
  this.timer = setTimeout(() => {
    this.handleAssignUser(value);
  }, 1000);
}


  renderPermissions=()=>{
    let{privacy, invitedUsers, displayUsers, isUserList, customUser}=this.state
    if(privacy=='ENTERPRISE'){
      return(
        <span className="permissionsContainer">
         {/* <div className="float-right"> */}
           {/* <span id="permission-popover" style={{ marginRight: '10px' }} onClick={this.togglePersmission}><Tooltip /></span> */}
           <span className="dashboard-permission-label">Permissions:</span>
           {/* <Popover placement="left" isOpen={this.state.permissionPopoverOpen} target="permission-popover" toggle={this.togglePersmission}>
             <PopoverHeader className="popover-header-tooltip">Permissions</PopoverHeader>
             <PopoverBody className="popover-body-tooltip">Toggle from “View Only” to “View and Edit” to allow others you have shared this chart with, to make modifications to it. Note, you can always change the privacy settings and permissions again and/or at a later time.</PopoverBody>
           </Popover> */}
         {/* </div> */}
         <div className="dashboardPermissionOptions">
           <span className="dbPermissionValue">View Only</span>
           <span className="ml10">
             <Toggle
               defaultChecked={this.state.permission === 'EDIT'}
               icons={false}
               onChange={this.handlePermissionChange}
             />
           </span>
           <span className="dbPermissionValue ml10">View And Edit</span>
         </div>
       </span>
      )
    } else if(privacy=='CUSTOM' && isUserList){
      return(
        <span>
          {/* <Col sm={3} md={3} lg={3}>
            <div className="float-right">
              <span id="permission-popover" style={{ marginRight: '10px' }} onClick={this.togglePersmission}><Tooltip /></span>
                <span className="chart-permission-label float-right">
                  <span>Shared with</span>
                </span>
              <Popover placement="left" isOpen={this.state.permissionPopoverOpen} target="permission-popover" toggle={this.togglePersmission}>
                <PopoverHeader className="popover-header-tooltip"> Sharing </PopoverHeader>
                <PopoverBody className="popover-body-tooltip">
                  Selects users you would like to share this dashboard with.
                  </PopoverBody>
              </Popover>
            </div>
          </Col> */}

              {/* <Col sm={2} className="">
                <div className="chartLabel">Select Users</div>
              </Col> */}
             <span className="permissionsContainer"  ref={this.viewUserInputRef} >
              <Input
             
                    name="assignedUser"
                    id=""
                    placeholder={"Select users to share this dashboard with"} 
                    className="inputBox-height"
                    onChange={this.assignedUserDelay}
                    value={customUser} 
                  />
                    {displayUsers && displayUsers.length>0 && typeof(displayUsers)!=='string'?
                            <div className="divTableSingleTask"   ref={this.viewUserTableRef} >
                            <div className="dbTableBody">
                                
                                  {displayUsers.map( user => {
                                    return (
                                        <div className="divTableRow" 
                                        onClick={()=>this.onUserSelect(user)} 
                                        key={user._id+user.organizationId}>
                                            <div className="dashboardTableCell">
                                              {user.firstName} {user.lastName}
                                            </div>
                                        </div>
                                    )
                                  })}
                            </div>
                            </div>
                      :
                      typeof(displayUsers)==='string'?
                      <span className='noUsersFound'>
                        {displayUsers}
                      </span>
                      :null
                      }
              
               
               </span>
               
               {invitedUsers.length>0?
              <Table responsive hover className="dbPrivacyTable">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Access</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {invitedUsers.map(e=>{
                    let fullName= e.firstName + " " +e.lastName
                    return(
                      <tr className="dbPrivacyRow" key={e.userId} >
                        
                        <td >
                          {fullName}
                        </td>

                          <td>
                                <Select
                                  isClearable={false}

                                    name="permission-select" 
                                    placeholder={"Select a permission/privacy"} 
                                    value={e.permissions} 
                                    isOpen={true}
                                    options={[
                                      {label: 'View', value:0},
                                      {label: 'Edit', value:1},
                                    ]} 
                                    onChange={itm =>this.onUserSetPermissions(itm, e)}  
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    />
                          </td>

                          <td className="dbRemoveUserCol">
                            <i onClick={()=>this.removeUser(e)} className="dashboardUserIcon flaticon-trash"></i>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
                </Table>
            :
            null}
      
          </span>
      )
    }
  }



handleAssignUser = value => {
  // console.log('val---', value)
  let res
  if(value && value.length>0){
    axios.get(url.findUser(value)).then( (resp,idx) =>{
      let users = resp.data.data
      // console.log('users--', users)
      if(users.length==0){
        users = 'No users found'
      }


      this.setState({displayUsers:users})
    })
  } else {
    this.setState({displayUsers:[]})
  }
}

  privacySettingsModal=()=>{
    this.setState((prevState)=> ({
      isPrivacy: !prevState.isPrivacy  
    }))
  }

  closeActionsModal=()=>{
    let{updatedFields}=this.state
   
    this.setState((prevState)=> ({
      ...newDashboard,
      isPrivacy: false,
      updatedFields:[]
    }))
  }

  changePrivacySettings=()=>{
    this.setState((prevState)=> ({
      isPrivacy: false 
    }))
  }

  toggleFilterDd=()=>{
    this.setState( prevState=>({
      dropdownFilter: !prevState.dropdownFilter
    }));
  }

  showFilterMenu=(type)=>{
    this.setState({activeFilterMenu:type})
  }

  clearActiveMenu=()=>{
    this.setState({activeFilterMenu:''})
  }

  renderActiveMenu=()=>{
    let{activeFilterMenu}=this.state
    // console.log('activeFilterMenu: ', activeFilterMenu)
    if(activeFilterMenu=='date'){
      return this.renderDatePicker()
    }
  }


  renderFilterDropdown=()=>{
    let{dropdownFilter, activeFilterMenu}=this.state
    // console.log('dropdownFilter: ', dropdownFilter)
    if(dropdownFilter){
    return(
      <ul className="dbFilterDropdown">
        <span className='dbFilterLabel'>Choose filters</span>
        {activeFilterMenu==''?
        <span>
          
          <ol onClick={()=>this.showFilterMenu('date')}> Date Range </ol>
          <ol onClick={()=>this.showFilterMenu('category')}> Category </ol>
        </span>
        :
        this.renderActiveMenu()
      }
      </ul>
    )
    }
  }

  handleStartDatePicker = (id) => { document.getElementById(id).click() }
  
  handleEndDateChange = date => {
    if (this.state.startDate!=null && date < this.state.startDate) {
      this.setState({
        endDate: this.state.startDate,
        error: false
      });
    } else {
      this.setState({
        endDate: date,
        error: false
      });
    }
  };

  handleStartDateChange = date => {
    // console.log(date)
    if (this.state.endDate!==null && date > this.state.endDate) {
      this.setState({
        startDate: this.state.endDate,
        error: false
      });
    } else {
      this.setState({
        startDate: date,
        error: false
      });
    }
  };
  openDatePicker = (id) => {
    document.getElementById(id).click();
  };

  renderDatePicker=()=>{
      return (
        <div className="dateFilterContainer">
         <span className="dashboardDateOptions" onClick={()=>this.clearActiveMenu()}> {'< '}Back </span>
       <div>
        <div className="inner-addon right-addon dateFilterPicker">
          {/* Start Date */}
        <span className="tool-start-date flaticon-calendar" 
          onClick={() => this.openDatePicker('startDatePicker')} />
        <DatePicker id="startDatePicker" placeholderText="Select start date" 
          className="input-custom-date form-control" 
          selectsStart showYearDropdown 
          selected={this.state.startDate}
           onChange={this.handleStartDateChange} 
           startDate={this.state.startDate} 
           endDate={this.state.endDate} maxDate={moment(new Date())} />
      </div>
        <span className="mg10">to</span>
      <div className="inner-addon right-addon dateFilterPicker">
        {/* End Date */}
              <span className="tool-end-date">
                <span className="flaticon-calendar" onClick={() => this.openDatePicker('endDatePicker')} />
              </span>
              <DatePicker id="endDatePicker" placeholderText="Select end date" className="input-custom-date form-control" 
              selectsEnd showYearDropdown 
              selected={this.state.endDate} 
              onChange={this.handleEndDateChange} startDate={moment.utc(this.state.startDate)} 
              endDate={this.state.endDate} disabled={!this.state.startDate} 
              minDate={this.state.startDate} maxDate={moment(new Date())}  />
            </div>
            </div>

     
            {/* <div className="dashboardDateOptions apply" onClick={()=>this.applyDateFilter()}>Apply</div> */}
            <Button outline color="primary" className="dashboardDateOptions" onClick={()=>this.applyDateFilter()}> Apply </Button>
      </div>
      )
  }

  applyDateFilter=()=>{
    let{startDate,endDate}=this.state
    this.setState({
      isDateApplied:true,
      dropdownFilter:false, 
      activeFilterMenu:''
    })
    this.props.dateChange(startDate,endDate)
  }


  createDashboard=()=>{
    let{title, permission, privacy, invitedUsers}=this.state

    let isTitle = title.replace(/<\/?![^>]+(>|$)/g, "").replace(/[\. ,:-]+/g, "").replace(/^\n|\n$/g, '').length>0

    if(isTitle) {

      this.setState({errMsg:'', preventCreate:true})
      
      let payload={
        name:title, permission, privacy, invitedUsers
      }
      let that=this
      axios.post(url.createDashboard, payload).then((response) => {
        // /dashboard/:orgId/view/:id
        this.setState({preventCreate:false})

        let dbId = response.data.data._id
        that.props.history.push(`/home/dashboard/${that.props.user.profile.organizationId._id}/view/${dbId}`)
      }).catch((error) => { console.log(error) });
    } else {
      this.setState({errMsg:'Almost there! Please provide a meaningful name so we can create this great dashboard.'})
    }
  }

  closeAlertMsg=()=>{
    this.setState({errMsg:''})
  }


  newDashboardUrl=(url)=>{

    this.props.newDashboardUrl(url)

  }

  render() {
    let {isUserList, privacy, isDateApplied,
      updatedFields, title, isPrivacy, startDate, endDate,
      invitedUsers, displayUsers,preventCreate, errMsg} = this.state;

    return (
      <span className="dashboardSettingsContainer">
      
       <Button color="info" className="dashboardListContainerBtn" onClick={()=>this.setState({isPrivacy:true})}> Create a dashboard </Button>


       <CreateDashboard isCreateModal={isPrivacy} closeActionsModal={this.closeActionsModal} newDashboardUrl={this.newDashboardUrl}/>





      </span>
    );
  }
}


const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onKpiMasterListFetched: (data) => dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: (data) => dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: (data) => dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Loading(DashboardSettings, axios)));

